import { Moment } from "moment";
import "./daily-insights.scss";
import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import api from "api";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import { actions } from "redux/reducers";
import ReactECharts from "echarts-for-react";

function DailyInsights({
    projectId,
    dateFrom,
    dateTo,
    streamIds,
    projectTypeId,
    section,
    competitors,
    clips,
}: {
    projectId: number;
    dateFrom: Moment;
    dateTo: Moment;
    streamIds: number[];
    projectTypeId: number;
    section: string;
    competitors?: any[];
    clips?: any[];
}) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const [dailyInsights, setDailyInsights] = useState<any[]>([]);
    const [chartData, setChartData] = useState<any[]>([]);
    const [legend, setLegend] = useState<string[]>([]);
    const [xAxis, setXAxis] = useState<string[]>([]);
    const [chartOptions, setChartOptions] = useState<any>();

    const getDailyInsights = useCallback(async () => {
        const d = await api.dailyInsights.getAll(projectId, dateFrom, dateTo, streamIds);
        if (d.length) {
            setDailyInsights(d);
        }
    }, [projectId, dateFrom, dateTo, streamIds]);

    useEffect(() => {
        getDailyInsights();
    }, [getDailyInsights]);

    const getStream = (streamId: number) => {
        return (
            {
                7: {
                    name: "X",
                    color: "#000",
                },
                8: {
                    name: "Facebook",
                    color: "#3b5998",
                },
                9: {
                    name: "Instagram",
                    color: "#e1306c",
                },
                10: {
                    name: "YouTube",
                    color: "#f61c0d",
                },
                11: {
                    name: "LinkedIn",
                    color: "#2977c9",
                },
                12: {
                    name: "TikTok",
                    color: "#000",
                },
            }[streamId] || { name: "", color: "" }
        );
    };

    const getStreamId = (name: string) => {
        return (
            {
                X: 7,
                Facebook: 8,
                Instagram: 9,
                YouTube: 10,
                LinkedIn: 11,
                TikTok: 12,
            }[name] || 0
        );
    };

    //x-axis date allocation
    useEffect(() => {
        if (dailyInsights.length > 0) {
            let _xAxis: string[] = [];
            const days = dateTo.diff(dateFrom, "days");
            let arr: any[] = [];

            //this whole section could be refactored and simplified
            if (days >= 30 && days < 90) {
                for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(7, "days")) {
                    let dtFrom = i;
                    let dtTo = i.clone().add(6, "d");
                    if (dtTo > moment()) {
                        dtTo = moment();
                    }
                    _xAxis.push(`${dtFrom.format("D MMM YYYY")} - ${dtTo.format("D MMM YYYY")}`);
                    setXAxis(_xAxis);
                }
                //Project ---------------------------
                if (section === "project") {
                    for (let i = 0; i < streamIds.length; i++) {
                        arr.push([]);
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(7, "days")) {
                            let dtFrom = j;
                            let dtTo = j.clone().add(6, "d");
                            if (dtTo > moment()) {
                                dtTo = moment();
                            }

                            const c = dailyInsights.find((x) => x.StreamId === streamIds[i] && moment(x.Date).add(2, "hours").isBetween(dtFrom.add(2, "hours"), dtTo.add(2, "hours")));

                            if (c) {
                                arr[i].push(c.Count);
                            } else {
                                arr[i].push(0);
                            }
                        }
                        setChartData(arr);
                    }
                }
                //Competitor Tracking -----------------
                if (section === "competitor-tracking" && competitors && clips) {
                    for (let i = 0; i < competitors.length; i++) {
                        arr.push([]);
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(7, "days")) {
                            let dtFrom = j;
                            let dtTo = j.clone().add(6, "d");
                            if (dtTo > moment()) {
                                dtTo = moment();
                            }
                            const clipCount = clips.filter((clip) => clip.BinId === competitors[i].BinId && moment(clip.DatePosted).add(2, "hours").isBetween(dtFrom.add(2, "hours"), dtTo.add(2, "hours"))).length;
                            if (clipCount > 0) {
                                arr[i].push(clipCount);
                            } else {
                                arr[i].push(0);
                            }
                            setChartData(arr);
                        }
                    }
                }
            } else if (days >= 90) {
                for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(1, "month")) {
                    let dtFrom = i;
                    let dtTo = i.clone().add(1, "M").subtract(1, "d");
                    if (dtTo > moment()) {
                        dtTo = moment();
                    }
                    _xAxis.push(`${dtFrom.format("D MMM YYYY")} - ${dtTo.format("D MMM YYYY")}`);
                    setXAxis(_xAxis);
                }
                if (section === "project") {
                    for (let i = 0; i < streamIds.length; i++) {
                        arr.push([]);
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(1, "month")) {
                            let dtFrom = j;
                            let dtTo = j.clone().add(1, "M").subtract(1, "d");
                            if (dtTo > moment()) {
                                dtTo = moment();
                            }
                            const c = dailyInsights.find((x) => x.StreamId === streamIds[i] && moment(x.Date).add(2, "hours").isBetween(dtFrom.add(2, "hours"), dtTo.add(2, "hours")));
                            if (c) {
                                arr[i].push(c.Count);
                            } else {
                                arr[i].push(0);
                            }
                            setChartData(arr);
                        }
                    }
                }
                if (section === "competitor-tracking" && competitors && clips) {
                    for (let i = 0; i < competitors.length; i++) {
                        arr.push([]);
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(1, "month")) {
                            let dtFrom = j;
                            let dtTo = j.clone().add(1, "M").subtract(1, "d");
                            if (dtTo > moment()) {
                                dtTo = moment();
                            }
                            const clipCount = clips.filter((clip) => clip.BinsId === competitors[i].BinId && moment(clip.DatePosted).add(2, "hours").isBetween(dtFrom.add(2, "hours"), dtTo.add(2, "hours"))).length;
                            if (clipCount > 0) {
                                arr[i].push(clipCount);
                            } else {
                                arr[i].push(0);
                            }
                            setChartData(arr);
                        }
                    }
                }
            } else {
                for (let i = dateFrom.clone(); i.isSameOrBefore(dateTo); i.add(1, "day")) {
                    _xAxis.push(`${i.format("D MMM YYYY")}`);
                    setXAxis(_xAxis);
                }
                //if the param indicating the section is for competitor tracking
                if (competitors && clips) {
                    //step through each competitor
                    for (let i = 0; i < competitors.length; i++) {
                        arr.push([]);
                        //step through each date/data node
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(1, "day")) {
                            //if there are clips with a binId that match the competitor binId then increment the clip count
                            let clipCount = clips.filter((clip) => clip.BinId === competitors[i].BinId && moment(clip.DatePosted).add(2, "hours").format("D MMM YYYY") === j.format("D MMM YYYY")).length;
                            if (clipCount > 0) {
                                arr[i].push(clipCount);
                            } else {
                                arr[i].push(0);
                            }
                        }
                    }
                    setChartData(arr);
                }
                if (section === "project") {
                    for (let i = 0; i < streamIds.length; i++) {
                        arr.push([]);
                        for (let j = dateFrom.clone(); j.isSameOrBefore(dateTo); j.add(1, "day")) {
                            const c = dailyInsights.find((x) => x.StreamId === streamIds[i] && moment(x.Date).add(2, "hours").format("D MMM YYYY") === j.format("D MMM YYYY"));
                            if (c) {
                                arr[i].push(c.Count);
                            } else {
                                arr[i].push(0);
                            }
                            setChartData(arr);
                        }
                    }
                }
            }
        }
    }, [dailyInsights, clips, competitors, dateFrom, dateTo, section, , streamIds]);

    useEffect(() => {
        if (competitors) {
            setLegend(competitors.map((item) => item.Name));
        }
        if (section === "project") {
            setLegend(streamIds.map((x) => getStream(x).name));
        }
    }, [competitors, streamIds, section]);

    const onClick = useCallback(
        async (e: any) => {
            e.event.stop();
            dispatch(
                actions.clipTray.set({
                    loading: true,
                    clips: [],
                    open: true,
                })
            );
            const dtFrom = e.name.split(" - ")[0];
            const dtTo = e.name.split(" - ")[1];
            const streamId = getStreamId(e.seriesName);
            const clips = await api.clip.getAll(params.projectId, moment(dtFrom), dtTo ? moment(dtTo) : moment(dtFrom).add(1, "d"), streamId.toString());
            dispatch(
                actions.clipTray.set({
                    loading: false,
                    clips: clips,
                    open: true,
                })
            );
        },
        [params.projectId, clips]
    );

    useEffect(() => {
        if (section === "project") {
            setChartOptions({
                tooltip: {},
                legend: {
                    data: legend,
                    top: 10,
                },
                grid: {
                    left: 30,
                    right: 10,
                    top: 45,
                    bottom: 20,
                },
                xAxis: {
                    data: xAxis,
                },
                yAxis: {
                    minInterval: 1,
                },
                series: streamIds.map((x: number, i: number) => {
                    return {
                        name: getStream(x).name,
                        type: "bar",
                        color: getStream(x).color,
                        data: chartData[i],
                    };
                }),
            });
        } else {
            setChartOptions({
                tooltip: {},
                legend: {
                    data: legend,
                    top: 10,
                },
                grid: {
                    left: 30,
                    right: 10,
                    top: 45,
                    bottom: 20,
                },
                xAxis: {
                    data: xAxis,
                },
                yAxis: {
                    minInterval: 1,
                },
                series: competitors?.map((item: any, index: number) => {
                    return {
                        name: item.Name,
                        type: "line",
                        data: chartData[index],
                    };
                }),
            });
        }
    }, [section, chartData, legend, streamIds, xAxis, competitors]);

    //if the page that it's being rendered on is the competitor-tracking page
    if (section === "competitor-tracking" && competitors) {
        return (
            <>
                <div className="top">
                    <p>Daily Insights</p>
                </div>
                <ReactECharts
                    option={{
                        tooltip: {},
                        legend: {
                            data: legend,
                            top: 10,
                        },
                        grid: {
                            left: 30,
                            right: 10,
                            top: 45,
                            bottom: 20,
                        },
                        xAxis: {
                            data: xAxis,
                        },
                        yAxis: {
                            minInterval: 1,
                        },
                        series: competitors?.map((item: any, index: number) => {
                            return {
                                name: item.Name,
                                type: "line",
                                data: chartData[index],
                            };
                        }),
                    }}
                    // notMerge={true}
                    onEvents={{
                        click: onClick,
                    }}
                />
            </>
        );
    }
    if (section === "project") {
        return (
            <div className="daily-insights" style={[2, 3, 8, 9].includes(projectTypeId) ? { width: "100%" } : {}}>
                <div className="top">
                    <p>Daily Insights</p>
                </div>
                <div className="body">
                    {chartOptions && (
                        <ReactECharts
                            option={chartOptions}
                            notMerge={true}
                            onEvents={{
                                click: onClick,
                            }}
                        />
                    )}
                </div>
            </div>
        );
    } else {
        return <></>;
    }
}

export default DailyInsights;
